import { ReactNode } from 'react';
import { TiltPermissionContext } from './useTiltPermissionForSection';
import { useTiltPermissionGate } from './useTiltPermissionGate';

export interface TiltPermissionProviderProps {
    /** `data-track-location` for the toast's own action and close controls. */
    trackLocation: string;
    children: ReactNode;
}

/**
 * Owns the tilt permission ask, so one answer covers the whole visit rather than each career.
 * Mounted above the route Suspense boundary, since anything narrower is torn down by ordinary
 * navigation and asks again on the way back.
 */
export const TiltPermissionProvider = ({ trackLocation, children }: TiltPermissionProviderProps) => {
    const gate = useTiltPermissionGate({ trackLocation });

    return <TiltPermissionContext.Provider value={gate}>{children}</TiltPermissionContext.Provider>;
};
